import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './EditPasswordForm.jsx'

export default createSubmit(name)